import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { flags } from './flags';
import { OverridesProvider } from './overrides-context';
import { buildContext } from './utils';
import { FlagsJsAccess } from './flags-js-access';
import { ContextUpdater } from './context-updater';
export var FeatureFlagsProvider = function (props) {
    var _a = useState(null), LDProvider = _a[0], setLDProvider = _a[1];
    useEffect(function () {
        var ldProviderConfig = {
            clientSideID: props.clientSideId,
            flags: flags,
            context: buildContext({
                brandId: props.brandId,
                shopId: props.shopId,
                barberId: props.barberId,
            }),
        };
        if (!props.clientSideId) {
            ldProviderConfig.options = {
                bootstrap: flags,
            };
        }
        asyncWithLDProvider(ldProviderConfig).then(function (provider) {
            setLDProvider(function () { return provider; });
        });
    }, [props.clientSideId]);
    if (!LDProvider) {
        return null;
    }
    return (_jsx(OverridesProvider, { children: _jsxs(LDProvider, { children: [props.children, _jsx(FlagsJsAccess, {}), _jsx(ContextUpdater, {})] }) }));
};
FeatureFlagsProvider.defaultProps = {
    brandId: null,
    shopId: null,
    barberId: null,
};
